import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'

import styles from './StatusContent.module.scss'
import fukkuStyles from 'fukku/styles/classes.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface StatusContentProps {
	'data-testid'?: string
	statusTitle?: string
	statusMessage?: string
	statusTitlePlaceholders?: object
	statusMessagePlaceholders?: object
	screenReaderText?: string
	isAlert?: boolean
	isMulti?: boolean
	className?: string
}

export function StatusContent({
	'data-testid': dataTestId,
	statusTitle,
	statusMessage,
	statusTitlePlaceholders,
	statusMessagePlaceholders,
	screenReaderText,
	isAlert,
	isMulti,
	className,
}: StatusContentProps) {
	const { t } = useLabels()

	return (
		<div className={cx(styles.container, isMulti && styles.multi, className)}>
			{screenReaderText && (
				<p className={fukkuStyles.srOnly}>{t(screenReaderText)}</p>
			)}
			{statusTitle && (
				<p
					className={text.uppercaseM}
					{...(dataTestId && { 'data-testid': `${dataTestId}.title` })}
				>
					<ClientLabel
						{...(statusTitlePlaceholders && {
							placeholderValues: { ...statusTitlePlaceholders },
						})}
					>
						{t(statusTitle)}
					</ClientLabel>
				</p>
			)}
			{statusMessage && (
				<p
					className={cx(
						styles.statusMessage,
						isMulti && text.uppercaseM,
						isAlert && styles.alert
					)}
					{...(dataTestId && { 'data-testid': `${dataTestId}.message` })}
				>
					<ClientLabel
						{...(statusMessagePlaceholders && {
							placeholderValues: { ...statusMessagePlaceholders },
						})}
					>
						{t(statusMessage)}
					</ClientLabel>
				</p>
			)}
		</div>
	)
}
